import { Navigate } from 'react-router-dom';
import { useDocumentTitle } from 'usehooks-ts';

import { Box, Flex } from 'ui/Layout';
import { Text } from 'ui/Typography';

import DiagramsOverview from '../components/DiagramsOverview';
import Page from '../components/Page';
import PageFooter from '../components/PageFooter';
import TopNavBar from '../components/TopNavBar';
import AdminNotOfficialEditorBanner from '../components/banners/AdminNotOfficialEditorBanner';
import CustomerExceededSankeysLimitBanner from '../components/banners/CustomerExceededSankeysLimitBanner';
import CustomerReachedSankeysLimitBanner from '../components/banners/CustomerReachedSankeysLimitBanner';
import NonCustomerExceededSankeysLimitBanner from '../components/banners/NonCustomerExceededSankeysLimitBanner';
import NonCustomerReachedSankeysLimitBanner from '../components/banners/NonCustomerReachedSankeysLimitBanner';
import { Path } from '../utils/routes';
import { useCurrentUser } from '../utils/user';

const SankeysPage: React.FC = () => {
  const { user } = useCurrentUser();

  useDocumentTitle('Sankey editor');

  // Redirect anonymous users to the main example
  if (!user?.is_authenticated) {
    return <Navigate to={Path.SankeyMainExample} replace />;
  }

  return (
    <Page>
      <TopNavBar>
        <Text color="gray.700">Diagrams overview</Text>
      </TopNavBar>
      <Box
        flexGrow={1}
        maxW="var(--chakra-breakpoints-xxl)"
        mx="auto"
        p={4}
        w="100%"
      >
        <Flex direction="column">
          <AdminNotOfficialEditorBanner />
          <CustomerExceededSankeysLimitBanner />
          <CustomerReachedSankeysLimitBanner />
          <NonCustomerExceededSankeysLimitBanner />
          <NonCustomerReachedSankeysLimitBanner />
        </Flex>
        <DiagramsOverview />
      </Box>
      <PageFooter />
    </Page>
  );
};

export default SankeysPage;
